export default "__VITE_ASSET__BirNuZ2s__"